import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const TABLET_SIZE = 1312

export default (props) => {

	const [isTablet, setIsTablet] = useState(window.innerWidth < TABLET_SIZE);

	useEffect(() => {
		const checkSize = function() {
			setIsTablet(window.innerWidth < TABLET_SIZE)
		}

		window.addEventListener("resize", checkSize);

		return () => {
			window.removeEventListener("resize", checkSize)
		}
	});

	return (

		<section className={`clients ${props.noButton ? 'no-button' : ''}`}>

			<div className="container">

				<h3>Trusted by companies of all shapes and sizes</h3>

				<div className="logos">

					{/* <a href="https://ladbrokes.com.au"target="_blank"><img src="/images/new/logos/clients/client-1.svg"/></a> */}
					<a href="https://www.fedex.com/" target="_blank"><img src="/images/new/logos/clients/client-23.svg"/></a>
					<a href="https://www.tnt.com/express/en_au/site/home.html"target="_blank"><img src="/images/new/logos/clients/client-7.svg"/></a>
					<a href="https://www.coinspot.com.au/"target="_blank"><img src="/images/new/logos/clients/client-14.svg"/></a>   
					{/* <a href="https://newscorpaustralia.com/"target="_blank"><img src="/images/new/logos/clients/client-4.svg"/></a>  */}
					<a href="https://teamglobalexp.com/"target="_blank"><img src="/images/new/logos/clients/client-8.svg"/></a>   
					{/* <a href="https://www.neds.com.au/"target="_blank"><img src="/images/new/logos/clients/client-9.svg"/></a> */}
					<a href="https://www.lotteryoffice.com.au/" target="_blank"><img src="/images/new/logos/clients/client-19.svg"/></a>
					<a href="https://www.cointree.com/"target="_blank"><img src="/images/new/logos/clients/client-17-new.svg"/></a>
					{/* <a href="https://coinjar.com.au/"target="_blank"><img src="/images/new/logos/clients/client-11.svg"/></a> */}
					<a href="https://www.playup.com.au/"target="_blank"><img src="/images/new/logos/clients/client-20.svg"/></a>
					<a href="https://goget.com.au/"target="_blank"><img src="/images/new/logos/clients/client-5.svg"/></a>
					<a href="https://www.sodaking.com.au/"target="_blank"><img src="/images/new/logos/clients/client-15.svg"/></a>
					<a href="https://www.booki.com.au/" target="_blank"><img src="/images/new/logos/clients/client-21.svg"/></a>
					<a href="https://www.colossalbet.com.au/" target="_blank"><img src="/images/new/logos/clients/client-22.svg"/></a>
					<a href="https://pay.weixin.qq.com/index.php/public/wechatpay"target="_blank"><img src="/images/new/logos/clients/client-3.svg"/></a>

				
					<a href="https://intl.alipay.com/"target="_blank"><img src="/images/new/logos/clients/client-2.svg"/></a>
				 
					
					{/* <a href="https://binancelite.com/"target="_blank"><img src="/images/new/logos/clients/client-10.svg"/></a> */}

					{/* <a href="https://www.rapyd.net/"target="_blank"><img src="/images/new/logos/clients/client-12.svg"/></a> */}
					{/* <a href="https://www.bitcoin.com.au/"target="_blank"><img src="/images/new/logos/clients/client-13.svg"/></a> */}

					
					{/* <a href="https://www.coinpoket.com/"target="_blank"><img src="/images/new/logos/clients/client-16.svg"/></a> */}
					<a href="https://www.mmg.com.au/"target="_blank"><img src="/images/new/logos/clients/client-18.svg"/></a>
						
				</div>

				<div className="tablet-logos">
				
					{/* <a href="https://ladbrokes.com.au"target="_blank"><img src="/images/new/logos/clients/tablet/client-1.svg"/></a> */}
					<a href="https://www.fedex.com/" target="_blank"><img src="/images/new/logos/clients/tablet/client-23.svg"/></a>
					<a href="https://www.tnt.com/express/en_au/site/home.html"target="_blank"><img src="/images/new/logos/clients/tablet/client-7.svg"/></a>
					<a href="https://www.coinspot.com.au/"target="_blank"><img src="/images/new/logos/clients/tablet/client-14.svg"/></a>   
					{/* <a href="https://newscorpaustralia.com/"target="_blank"><img src="/images/new/logos/clients/tablet/client-4.svg"/></a> */}
					<a href="https://teamglobalexp.com/"target="_blank"><img src="/images/new/logos/clients/tablet/client-8.svg"/></a> 
					{/* <a href="https://www.neds.com.au/"target="_blank"><img src="/images/new/logos/clients/tablet/client-9.svg"/></a> */}
					<a href="https://www.lotteryoffice.com.au/" target="_blank"><img src="/images/new/logos/clients/tablet/client-19.svg"/></a>
					<a href="https://www.cointree.com/"target="_blank"><img src="/images/new/logos/clients/tablet/client-17-new.svg"/></a>
					{/* <a href="https://coinjar.com.au/"target="_blank"><img src="/images/new/logos/clients/tablet/client-11.svg"/></a> */}
					<a href="https://www.playup.com.au/"target="_blank"><img src="/images/new/logos/clients/tablet/client-20.svg"/></a>
					<a href="https://goget.com.au/"target="_blank"><img src="/images/new/logos/clients/tablet/client-5.svg"/></a>
					<a href="https://www.sodaking.com.au/"target="_blank"><img src="/images/new/logos/clients/tablet/client-15.svg"/></a>
					<a href="https://www.booki.com.au/" target="_blank"><img src="/images/new/logos/clients/tablet/client-21.svg"/></a>
					<a href="https://www.colossalbet.com.au/" target="_blank"><img src="/images/new/logos/clients/tablet/client-22.svg"/></a>
					<a href="https://pay.weixin.qq.com/index.php/public/wechatpay"target="_blank"><img src="/images/new/logos/clients/tablet/client-3.svg"/></a>

					<a href="https://intl.alipay.com/"target="_blank"><img src="/images/new/logos/clients/tablet/client-2.svg"/></a>

	
					{/* <a href="https://binancelite.com/"target="_blank"><img src="/images/new/logos/clients/tablet/client-10.svg"/></a> */}

					{/* <a href="https://www.rapyd.net/"target="_blank"><img src="/images/new/logos/clients/tablet/client-12.svg"/></a> */}
					{/* <a href="https://www.bitcoin.com.au/"target="_blank"><img src="/images/new/logos/clients/tablet/client-13.svg"/></a> */}
 
				
					{/* <a href="https://www.coinpoket.com/"target="_blank"><img src="/images/new/logos/clients/tablet/client-16.svg"/></a> */}
			
					<a href="https://www.mmg.com.au/"target="_blank"><img src="/images/new/logos/clients/tablet/client-18.svg"/></a>					
				
				</div>

				<div className="mobile-logos">

					{/* <a href="https://ladbrokes.com.au"target="_blank"><img src="/images/new/logos/clients/mobile/client-1.svg"/></a> */}
					<a href="https://www.fedex.com/" target="_blank"><img src="/images/new/logos/clients/mobile/client-23.svg"/></a>
					<a href="https://www.tnt.com/express/en_au/site/home.html"target="_blank"><img src="/images/new/logos/clients/mobile/client-7.svg"/></a>
					<a href="https://www.coinspot.com.au/"target="_blank"><img src="/images/new/logos/clients/mobile/client-14.svg"/></a>  
					{/* <a href="https://newscorpaustralia.com/"target="_blank"><img src="/images/new/logos/clients/mobile/client-4.svg"/></a> */}
					<a href="https://teamglobalexp.com/"target="_blank"><img src="/images/new/logos/clients/mobile/client-8-old.svg"/></a>  
					{/* <a href="https://www.neds.com.au/"target="_blank"><img src="/images/new/logos/clients/mobile/client-9.svg"/></a> */}
					<a href="https://www.lotteryoffice.com.au/" target="_blank"><img src="/images/new/logos/clients/mobile/client-19.svg"/></a>
					<a href="https://www.cointree.com/"target="_blank"><img src="/images/new/logos/clients/mobile/client-17-new.svg"/></a>
					{/* <a href="https://coinjar.com.au/"target="_blank"><img src="/images/new/logos/clients/mobile/client-11.svg"/></a> */}
					<a href="https://www.playup.com.au/"target="_blank"><img src="/images/new/logos/clients/mobile/client-20.svg"/></a>
					<a href="https://goget.com.au/"target="_blank"><img src="/images/new/logos/clients/mobile/client-5.svg"/></a>
					<a href="https://www.sodaking.com.au/"target="_blank"><img src="/images/new/logos/clients/mobile/client-15.svg"/></a>
					<a href="https://www.booki.com.au/" target="_blank"><img src="/images/new/logos/clients/mobile/client-21.svg"/></a>
					<a href="https://www.colossalbet.com.au/" target="_blank"><img src="/images/new/logos/clients/mobile/client-22.svg"/></a>
					<a href="https://pay.weixin.qq.com/index.php/public/wechatpay"target="_blank"><img src="/images/new/logos/clients/mobile/client-3.svg"/></a>

					<a href="https://intl.alipay.com/"target="_blank"><img src="/images/new/logos/clients/mobile/client-2.svg"/></a>
					{/* <a href="https://binancelite.com/"target="_blank"><img src="/images/new/logos/clients/mobile/client-10.svg"/></a> */}

					{/* <a href="https://www.rapyd.net/"target="_blank"><img src="/images/new/logos/clients/mobile/client-12.svg"/></a> */}
					{/* <a href="https://www.bitcoin.com.au/"target="_blank"><img src="/images/new/logos/clients/mobile/client-13.svg"/></a> */}
  
				
					{/* <a href="https://www.coinpoket.com/"target="_blank"><img src="/images/new/logos/clients/mobile/client-16.svg"/></a> */}
					<a href="https://www.mmg.com.au/"target="_blank"><img src="/images/new/logos/clients/mobile/client-18.svg"/></a>
						
				</div>

				{ props.noButton ? null : <Link to="/clients" className="clients-button">SEE THE CASE STUDIES</Link> } 

			</div>

		</section>

	)
}


// WEBPACK FOOTER //
// ./client/components/ClientLogos/index.js